import React, { Component } from "react";
import { Link } from "react-router-dom";
import Auth from "../../services/Auth";
import { confirmAlert } from "react-confirm-alert";
import { connect } from "react-redux";
import ToggleNav from "./ToggleNav";
import "./Header.scss";
import Notification from "services/Notification";
import { ReactComponent as BellFill } from "../../assets/icons/bell_fill.svg";
import { UserLevel, NOTIFICATION_REFRESH_EVENT } from "utils/constant";
import { HashLoader } from "react-spinners";

const AuthService = new Auth();
const NotificationService = new Notification();

export const mapNotificationCounters = (data = {}) => ({
  importCase: data["import-case"] || 0,
  knowlesiLab: data["knowlesi-lab"] || 0,
  feedbackCase: data["feedback-case"] || 0,
  indigenousValidation: data["indigenous-validation"] || 0,
  caseBkk: data["case-bkk"] || 0,
  caseBkkDistrict: data["case-bkk-district"] || 0,
  caseBkkProvince: data["case-bkk-province"] || 0,
  peCaseBkk: data["pe-case-bkk"] || 0,
  peCase: data["pe-case"] || 0,
});

export const notificationRegionId = (user = {}) => {
  const regionField = {
    [UserLevel.Fasyankes]: "fasyankes_id",
    [UserLevel.District]: "district_id",
    [UserLevel.Province]: "province_id",
  }[user.level];
  if (regionField && user[regionField]) {
    return String(user[regionField]).split("|")[0];
  }
  return user.username;
};

class Header extends Component {
  handleLogout = () => {
    confirmAlert({
      title: "Anda yakin ingin keluar?",
      message: "Beberapa data mungkin belum tersimpan",
      buttons: [
        {
          label: "Ya",
          onClick: () => {
            this.setState({ loggingOut: true });
            AuthService.loggedOut();
          },
        },
        {
          label: "Tidak",
        },
      ],
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      importCase: 0,
      feedbackCase: 0,
      indigenousValidation: 0,
      peCase: 0,
      knowlesiLab: 0,
      caseBkk: 0,
      caseBkkDistrict: 0,
      caseBkkProvince: 0,
      peCaseBkk: 0,
      loading: true,
      loggingOut: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    window.addEventListener(NOTIFICATION_REFRESH_EVENT, this.getNotification);
    this.getNotification();
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener(NOTIFICATION_REFRESH_EVENT, this.getNotification);
  }

  getNotification = () => {
    this.setState({ loading: true, notif: null }, async () => {
      await NotificationService.get({
        regionId: notificationRegionId(this.props.user),
      })
        .then((data) => {
          if (this._isMounted) {
            this.setState({
              loading: false,
              ...mapNotificationCounters(data),
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ loading: false });
        });
    });
  };

  clearNotifications = () => {
    this.setState({ loading: true }, async () => {
      await NotificationService.reset({
        regionId: notificationRegionId(this.props.user),
      })
        .then((data) => {
          if (this._isMounted) {
            this.setState({
              loading: false,
              importCase: 0,
              peCase: 0,
              indigenousValidation: 0,
              feedbackCase: 0,
              knowlesiLab: 0,
              caseBkk: 0,
              caseBkkDistrict: 0,
              caseBkkProvince: 0,
              peCaseBkk: 0,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ loading: false });
        });
    });
  };

  render() {
    const { user, showNotif } = this.props;
    const {
      importCase,
      feedbackCase,
      indigenousValidation,
      peCase,
      knowlesiLab,
      caseBkk,
      caseBkkDistrict,
      caseBkkProvince,
      peCaseBkk,
    } = this.state;
    const showbBtnReset =
      importCase > 0 ||
      feedbackCase > 0 ||
      indigenousValidation > 0 ||
      peCase > 0 ||
      knowlesiLab > 0 ||
      caseBkk > 0 ||
      caseBkkDistrict > 0 ||
      caseBkkProvince > 0 ||
      peCaseBkk > 0;

    return (
      <div className="main-header">
        <div className="logo-header" data-background-color="white">
          <Link to="/" className="logo">
            <img
              src="/dist/img/logo/logo_kemkes.png"
              alt="navbar brand"
              className="navbar-brand"
              height="50"
            />
          </Link>
          <ToggleNav />
        </div>
        <nav
          className="navbar navbar-header navbar-expand-lg"
          data-background-color="bg3"
        >
          <div className="container-fluid">
            <ul className="navbar-nav topbar-nav ml-md-auto align-items-center">
              {(user.level === "District" ||
                user.level === "Fasyankes" ||
                user.level === UserLevel.Province ||
                user.level === UserLevel.BKKInduk ||
                user.level === UserLevel.BKKWilker) && (
                <li
                  className={
                    showNotif.show
                      ? "nav-item dropdown hidden-caret submenu show"
                      : "nav-item dropdown hidden-caret"
                  }
                >
                  <Link
                    className="dropdown-toggle profile-pic mr-2"
                    data-toggle="dropdown"
                    to="#"
                    aria-expanded={showNotif.show}
                  >
                    <BellFill
                      width="30px"
                      height="30px"
                      fill={showbBtnReset ? "#FF0000" : "#808080"}
                    />
                  </Link>
                  <ul
                    className={
                      showNotif.show
                        ? "dropdown-menu dropdown-user animated fadeIn show"
                        : "dropdown-menu dropdown-user animated fadeIn"
                    }
                  >
                    <div className="dropdown-user-scroll scrollbar-outer">
                      {/* Notification list */}
                      {user.level === "District" && (
                        <>
                          <li>
                            <Link
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              to="/notifikasi-kasus-impor"
                            >
                              Notifikasi Kasus Impor
                              <span className="badge badge-warning">
                                {importCase}
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              to="/validasi-indigenous"
                            >
                              Validasi Indigenous
                              <span className="badge badge-warning">
                                {indigenousValidation}
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              to="/notifikasi-kasus-bkk"
                            >
                              Kasus BKK
                              <span className="badge badge-warning">
                                {caseBkkDistrict}
                              </span>
                            </Link>
                          </li>
                        </>
                      )}
                      {user.level === "Fasyankes" && (
                        <>
                          {user.fasyankes_type_id === "jnsfas-01" && (
                            <>
                              <li>
                                <Link
                                  className="dropdown-item"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                  to="/pe-kasus"
                                >
                                  PE Kasus
                                  <span className="badge badge-warning">
                                    {peCase}
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className="dropdown-item"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                  to="/pe-kasus-bkk"
                                >
                                  PE Kasus BKK
                                  <span className="badge badge-warning">
                                    {peCaseBkk}
                                  </span>
                                </Link>
                              </li>
                            </>
                          )}
                          <li>
                            <Link
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              to="/notifikasi-pe-feedback"
                            >
                              PE Feedback
                              <span className="badge badge-warning">
                                {feedbackCase}
                              </span>
                            </Link>
                          </li>
                        </>
                      )}
                      {user.level === "Province" && (
                        <>
                          <li>
                            <Link
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              to="/notifikasi-kasus-bkk"
                            >
                              Kasus BKK
                              <span className="badge badge-warning">
                                {caseBkkProvince}
                              </span>
                            </Link>
                          </li>
                        </>
                      )}
                      {(user.level === UserLevel.BKKInduk ||
                        user.level === UserLevel.BKKWilker) && (
                        <>
                          <li>
                            <Link
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              to="/notifikasi-kasus-bkk"
                            >
                              Kasus BKK
                              <span className="badge badge-warning">
                                {caseBkk}
                              </span>
                            </Link>
                          </li>
                        </>
                      )}
                      {showbBtnReset && (
                        <li>
                          <div className="dropdown-divider" />
                          <span
                            className="dropdown-item text-danger"
                            style={{ cursor: "pointer" }}
                            onClick={this.clearNotifications}
                          >
                            Hapus notifikasi
                          </span>
                        </li>
                      )}
                    </div>
                  </ul>
                </li>
              )}

              {(user.level === UserLevel.LabTier5 ||
                user.level === UserLevel.LabTier3 ||
                user.level === UserLevel.LabTier4) && (
                <li
                  className={
                    showNotif.show
                      ? "nav-item dropdown hidden-caret submenu show"
                      : "nav-item dropdown hidden-caret"
                  }
                >
                  <Link
                    className="dropdown-toggle profile-pic mr-2"
                    data-toggle="dropdown"
                    to="#"
                    aria-expanded={showNotif.show}
                  >
                    <BellFill
                      width="30px"
                      height="30px"
                      fill={showbBtnReset ? "#FF0000" : "#808080"}
                    />
                  </Link>
                  <ul
                    className={
                      showNotif.show
                        ? "dropdown-menu dropdown-user animated fadeIn show"
                        : "dropdown-menu dropdown-user animated fadeIn"
                    }
                  >
                    <div className="dropdown-user-scroll scrollbar-outer">
                      <li>
                        <Link
                          className="dropdown-item"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          to={`/input-surveilans-knowlesi-lab${
                            user.level === UserLevel.LabTier5 ? "5" : ""
                          }`}
                        >
                          Notifikasi Kasus PK
                          <span className="badge badge-warning">
                            {knowlesiLab}
                          </span>
                        </Link>
                      </li>
                      {showbBtnReset && (
                        <li>
                          <div className="dropdown-divider" />
                          <span
                            className="dropdown-item text-danger"
                            style={{ cursor: "pointer" }}
                            onClick={this.clearNotifications}
                          >
                            Hapus notifikasi
                          </span>
                        </li>
                      )}
                    </div>
                  </ul>
                </li>
              )}

              <li className="nav-item dropdown hidden-caret">
                <Link
                  className="dropdown-toggle profile-pic"
                  data-toggle="dropdown"
                  to="#"
                  aria-expanded="false"
                >
                  <div className="avatar-sm">
                    <img
                      src={`https://ui-avatars.com/api/?name=${this.props.user.first_name}+${this.props.user.last_name}`}
                      alt={`${this.props.user.first_name} ${this.props.user.last_name}`}
                      className="avatar-img rounded-circle"
                    />
                  </div>
                </Link>
                <ul className="dropdown-menu dropdown-user animated fadeIn">
                  <div className="dropdown-user-scroll scrollbar-outer">
                    <li>
                      <div className="user-box">
                        <div className="avatar-lg">
                          <img
                            src={`https://ui-avatars.com/api/?name=${this.props.user.first_name}+${this.props.user.last_name}`}
                            alt={`${this.props.user.first_name} ${this.props.user.last_name}`}
                            className="avatar-img rounded"
                            style={{ minWidth: 50 }}
                          />
                        </div>
                        <div className="u-text">
                          <h4 style={{ lineHeight: 1.5 }}>
                            {this.props.user &&
                              this.props.user.first_name +
                                " " +
                                this.props.user.last_name}
                          </h4>
                          <p
                            style={{
                              fontSize: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            {this.props.user.fasyankes_id?.split("|")[1]}
                          </p>
                          <p className="text-muted">
                            <span className="badge badge-success">
                              {this.props.user && this.props.user.role}
                            </span>
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="dropdown-divider" />
                      <span
                        className="dropdown-item text-danger"
                        style={{
                          cursor: this.state.loggingOut
                            ? "not-allowed"
                            : "pointer",
                        }}
                        onClick={this.handleLogout}
                      >
                        Logout
                      </span>
                    </li>
                  </div>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        {/* End Navbar */}
        {this.state.loggingOut && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255, 255, 255, 0.7)",
            }}
          >
            <HashLoader size={80} color="#18b3ab" />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.currentUser,
    showNotif: state.showNotifReducer,
  };
};

export default connect(mapStateToProps)(Header);
